import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { animalService, Animal } from '../services/animalService';
import './Animals.css';

const DeceasedAnimals: React.FC = () => {
  const [animals, setAnimals] = useState<Animal[]>([]);
  const [loading, setLoading] = useState(true);
  const [markingAlive, setMarkingAlive] = useState<number | null>(null);

  useEffect(() => {
    loadDeceasedAnimals();
  }, []);

  const loadDeceasedAnimals = async () => {
    try {
      setLoading(true);
      const data = await animalService.getDeceasedAnimals();
      setAnimals(data);
    } catch (error: any) {
      console.error('Erro ao carregar animais falecidos:', error);
      if (error.response) {
        if (error.response.status === 401) return;
        alert(error.response.data?.error || 'Erro ao carregar animais falecidos');
      } else if (error.request) {
        alert('Erro ao conectar com o servidor. Verifique sua conexão.');
      } else {
        alert('Erro ao carregar animais falecidos. Tente novamente.');
      }
      setAnimals([]);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAlive = async (id: number) => {
    if (!window.confirm('Deseja marcar este animal como vivo? Ele voltará a aparecer na lista de animais cadastrados.')) {
      return;
    }

    try {
      setMarkingAlive(id);
      await animalService.updateAnimal(id, { status: 'vivo' });
      alert('Animal marcado como vivo!');
      loadDeceasedAnimals();
    } catch (error: any) {
      console.error('Erro ao marcar animal como vivo:', error);
      if (error.response) {
        alert(error.response.data?.error || 'Erro ao marcar como vivo');
      } else {
        alert('Erro ao marcar como vivo. Tente novamente.');
      }
    } finally {
      setMarkingAlive(null);
    }
  };

  if (loading) {
    return <div className="container">Carregando...</div>;
  }

  return (
    <div className="container">
      <div className="page-header">
        <h1>Animais Falecidos</h1>
        <Link to="/animals" className="btn btn-secondary">
          ← Voltar para Animais
        </Link>
      </div>

      <div className="card">
        <p style={{ marginBottom: '20px', color: '#666' }}>
          Estes são os animais marcados como falecidos. Você pode marcá-los novamente como vivos se necessário.
        </p>

        {animals.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
            <p>Nenhum animal falecido encontrado.</p>
          </div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Espécie</th>
                <th>Raça</th>
                <th>Microchip</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {animals.map((animal) => (
                <tr key={animal.id}>
                  <td>{animal.name}</td>
                  <td>{animal.species}</td>
                  <td>{animal.breed || '-'}</td>
                  <td>{animal.microchip?.number || animal.microchip_id || '-'}</td>
                  <td>
                    <button
                      onClick={() => handleMarkAlive(animal.id)}
                      className="btn btn-success"
                      disabled={markingAlive === animal.id}
                      style={{ marginBottom: '5px' }}
                    >
                      {markingAlive === animal.id ? 'Salvando...' : 'Marcar como vivo'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default DeceasedAnimals;
